import React from "react";

export default function AsteriskLabel({ style1 = {} }) {
  return <span style={{ color: "red", ...style1 }}>*</span>;
}
